import { LoggedIn } from '@gamiphy/loyalty-station-desktop/components/cashback/cashbackProgram/loggedIn';
import { NonLoggedIn } from '@gamiphy/loyalty-station-desktop/components/cashback/cashbackProgram/nonLoggedIn';
import { UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { GlobalStyles } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';

const CashbackMainContent: React.FC = () => {
  const content = React.useMemo(() => {
    if (UserStore.isLoggedIn || UiStore.signupFlowStarted) {
      return <LoggedIn />;
    }
    return <NonLoggedIn setStarted={(value) => UiStore.setSignupFlowStarted(value)} />;
  }, [UserStore.isLoggedIn, UiStore.signupFlowStarted]);

  return (
    <>
      <GlobalStyles styles={{ html: { fontSize: '10px' } }} />
      {content}
    </>
  );
};

export default observer(CashbackMainContent);
